module.exports = __webpack_public_path__ + "img/alert.421fee72.svg";